// extracted by mini-css-extract-plugin
export default {"companyContainer":"wO-z","companyImage":"xO-z","container":"yO-z","heading":"zO-z","darkText":"AO-z","smallHeading":"BO-z","darkBackground":"CO-z","whiteBackground":"DO-z"};